<template>
    <el-dialog
    title="学习评价"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="120rem">
    <span><img src="../../../assets/image/course/style.png" alt="" style="margin-right: 0.8rem;">评分</span>
    <div class="rate">
        <el-rate v-model="rate"></el-rate>
    </div>
    <div class="content">
        <div><img src="../../../assets/image/course/style.png" alt="" style="margin-right: 0.8rem;">评分内容</div>
    </div>
    <div class="t-box">
        <div v-for="(item,index) in radioArray" :key="index">
            <div>{{ index+1+'.'+item.evaluateItem }}</div>
            <el-radio-group v-model="item.value">
                <el-radio v-for="(ele) in item.evaluateItemContentVOList" class="radio-item" :key="ele.id" :label="ele.id">{{ ele.evaluateContent }}</el-radio>
            </el-radio-group>
        </div>
    </div>
    <div class="advice-box">
        <div style="padding: 2rem 0;"><img src="../../../assets/image/course/style.png" alt="" style="margin-right: 0.8rem;">建议</div>
        <el-input v-model="advice" type="textarea" placeholder="请输入您认为需要改进的地方或者需要增加的内容"></el-input>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" style="margin-left: 3.5rem;" @click="userEvaluate">确 定</el-button>
    </div>
    </el-dialog>
</template>

<script>
import {UserEvaluate,GetQuestionnairesEvaluateList} from '@/api/evaluate';
    export default {
        data(){
            return {
                dialogVisible:false,
                rate:0,
                radioArray:[],
                advice:'',
                businessType:'',
                id:''
            }
        },
        methods:{
            /**获取问卷评价列表 */
            getQuestionnairesEvaluateList(callback){
                GetQuestionnairesEvaluateList().then((res)=>{
                    if(res.code==200){
                        this.radioArray=res.data;
                        this.radioArray.forEach(item=>{
                            this.$set(item,'value','');
                        })
                        typeof callback=='function'&&callback();
                    }
                })
            },
            /**用户评价 */
            userEvaluate(){
                var arr=[];
                for(var item of this.radioArray){
                    if(!item.value){
                        this.$msg({
                                showClose: true,
                                message: "评价选项未填写完成",
                                type: "warning",
                            });
                        return;
                    }
                    var obj={
                        "id": "",
                        "ids": []
                        }
                    obj.id=item.id;
                    obj.ids=[item.value];
                    arr.push(obj);
                }
                if(!this.advice){
                    this.$msg({
                                showClose: true,
                                message: "请填写您的建议",
                                type: "warning",
                            });
                    return;
                };
                var params=[{
                    "businessId": this.id,
                    "businessType": this.businessType,
                    "evaluateContent": this.advice,
                    "evaluateScore": this.rate,
                    "evaluateType": "general"
                    },
                    {
                    "addEvaluateItemPOS": arr,
                    "businessId": this.id,
                    "businessType": this.businessType,
                    "evaluateType": "questionnaire"
                    }]
                UserEvaluate(params).then(res=>{
                    if(res.code==200){
                        this.$msg({
                                showClose: true,
                                message: "评价成功",
                                type: "success",
                            });
                        this.dialogVisible=false;
                        this.$emit('evaluate_success');
                    }
                })
            },
        },
    }
</script>

<style lang="less" scoped>
.dialog-footer{
    padding: 6rem 0 2.5rem 0;
    text-align: center;
}
.rate{
    margin-top: 1rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #EAEBF0;
}
.content{
    display: flex;
    padding: 2rem 0;
    &> :nth-child(2){
        color: #8590B3;
    }
}
.t-box{
    padding: 2rem 3rem;
    border: 1px solid #E8ECEF;
    height: 40rem;
    overflow: auto;
    &> :nth-child(n){
        margin-top: 3.5rem;
    }
    &> :nth-child(1){
        margin-top: 0;
    }
}
/deep/.el-dialog{
    border-radius: 2rem;
}
/deep/.el-radio-group{
    display: flex;
    flex-direction: column;
}
/deep/.el-radio__label{
    color: #8590B3;
}
.radio-item{
    margin-top: 2rem;
}
@media screen and (max-width:650px){
    /deep/.el-dialog{
   width: 65rem !important;
}
}
</style>